// extracted by mini-css-extract-plugin
export var container = "_5m-0";
export var infoButton = "_5m-1";
export var label = "_5m-3";
export var labelExpanded = "_5m-4";
export var price = "_5m-5";
export var priceExpanded = "_5m-6";
export var title = "_5m-2";